const localization = {
  dashboardPage: {
    executiveHeading: "Executive Summary",
    executiveText: "Overall User / System and Revenue Analysis",
    totalRegistered: "Total registered companies",
    totalRegisteredHead: "Total Registered",
    totalActive: "Total active companies",
    totalActiveHead: "Total Active",
    totalPaid: "Total Paid (Inc. Credit)",
    totalPaidHead: "Paid Bills",
    salesOrderTab: "Sales Order",
    quotationsTab: "Quotations",
    rfqTab: "Manage RFQ's",
  },
  clientsListing: {
    heading: "Clients",
    allClientsTab: "All Clients",
    allClientsTabSub: "All Sub Users",
    clientsListingLink1: "View Client",
    clientsListingLink2: "Dashboard",
    pendingInvitations: "Pending Invitations",
    pendingInvitationsSub: "Pending Invitations",
    signupButton: "Signup Link",
    inviteButton: "Invite New Client",
    addNewButton: "Add New Client",
    inviteButtonSub: "Invite New Sub User",
    addNewButtonSub: "Add New Sub User",
  },
  clientsAgreementsListing: {
    heading: "Client Agreements",
    allAgreementsTab: "Client Agreements",
    allAgreementsTabSub: "Client Agreements",
    agreementsListingLink1: "Edit Agreement",
    agreementsListingLink2: "Delete Agreement",
    archivedTab: "Archived",
    archivedTabSub: "Archived",
    addNewButton: "Add New Agreement",
  },
  clientsRoles: {
    heading: "Client Control Panel",
    mainRolesTab: "Roles",
    mainRolesSub: "Client Roles",
    mainRoleLink: "Edit Role",
    subRoleTab: "Sub Roles",
    subRoleTabSub: "Client Sub Roles",
    subRoleLink: "Edit Sub Role",
    addNewButton: "Add New Role",
    addNewButtonLink1: "New Role",
    addNewButtonLink2: "New Sub Role",
  },
  productListing: {
    heading: "Products & Services",
    addNewButton: "Add New",
    selectServiceType: "Select Service Type",
    selectServiceTypePlaceHolder: "Select a service type to view its services.",
    selectServiceTypeEmpty: "Service type not found",
    listingLink1: "Edit Product",
    listingLink2: "View Product",
    detailsPopupHead: "Product Details",
    detailsPopupOtherServicesHead: "Other Service Rates",
    detailsPopupCancellationHead: "Cancellation Fee",
    detailsPopupCancellationText: "Cancellation Fee",
    detailsPopupDatesHead: "Add / Update Dates",
    detailsPopupDatesAdd: "Date Added",
    detailsPopupDatesUpdate: "Date Updated",
    detailsPopupDescriptionHead: "Description",
    detailsPopupSummary: "Summary",
    detailsPopupMiscHead: "Usage Rates",
    detailsPopupMarketingHead: "Marketing Link",
    detailsPopupMarketingText: "Marketing Link",
    detailsPopupMarketingLinkOpen: "Click to open link",
    detailsPopupMarketingLinkView: "View PDF",
    detailsPopupIntegration: "3rd Party Integration",
  },
  addProduct: {
    miscHeading: "Miscellaneous Rates / Cancellation Fee",
    miscHeadingText:
      "Miscellaneous rates, fees and charges may apply and are in addition to the applicable Service rates and charges. You can add the cancellation fee and up to 5 miscellaneous rates here.",
    miscSubHeading: "Miscellaneous Rates",
    miscSubHeadingTip:
      "Miscellaneous Rates. Up to 5 miscellaneous rates are allowed",
  },
  editProduct: {
    miscHeading: "Miscellaneous Rates / Cancellation Fee",
    miscHeadingText:
      "Miscellaneous rates, fees and charges may apply and are in addition to the applicable Service rates and charges. You can add the cancellation fee and up to 5 miscellaneous rates here.",
    miscSubHeading: "Miscellaneous Rates",
    miscSubHeadingTip:
      "Miscellaneous Rates. Up to 5 miscellaneous rates are allowed",
  },
  productTypeListing: {
    heading: "Products & Services Types",
    addNewButton: "Add New",
    listingLink1: "Edit",
    listingLink2: "Default Value",
    listingLink3: "Unarchive",
  },
  //Agent Listing
  agentsListing: {
    heading: "Partners",
    signupButton: "Partner Signup Link",
    inviteButton: "Invite New Partner",
    addNewButton: "Add New Partner",
    allCPTab: "All Partner",
    listingLink1: "Edit Partner",
    listingLink2: "Agreements",
    listingLink3: "Commissions",
    listingLink4: "Sub Partner",
    listingLink5: "Assign Menu",
    listingLink6: "Dashboard",
    invitationTab: "Pending Invitations",
    signupLinkPopupHeading: "Partner Signup Link",
    signupLinkPopupSubHeading1: "Partner Signup Link",
    signupLinkPopupSub1Note: "NOTE: Use this link to invite partners to join.",
    signupLinkPopupSubHeading2: "Partner Login URL",
    subSignupLinkPopupHeading: "Sub User Signup Link",
    subSignupLinkPopupNote:
      "NOTE: Anyone with this link will be able to create a sub user for this partner. Be very careful where and how you send this! It is also a good idea to make sure you have any supporting documents and contracts in place before you allow the partner to have its first sub user.",
    listingLink7: "Login Details",
  },
  agentAgreementsListing: {
    heading: "Agent Agreements",
    allAgreementsTab: "Agent Agreements",
    allAgreementsTabSub: "Agent Agreements",
    agreementsListingLink1: "Edit Agreement",
    agreementsListingLink2: "Delete Agreement",
    archivedTab: "Archived",
    archivedTabSub: "Archived",
    addNewButton: "Add New Agreement",
  },
  //Agent Roles
  agentRoles: {
    heading: "Control Panel",
    mainRolesTab: "Roles",
    mainRolesSub: "Agent Roles",
    mainRoleLink: "Edit Role",
    subRoleTab: "Sub Roles",
    subRoleTabSub: "Agent Sub Roles",
    subRoleLink: "Edit Sub Role",
    addNewButton: "Add New Role",
    addNewButtonLink1: "New Role",
    addNewButtonLink2: "New Sub Role",
  },
  quotationListing: {
    heading: "Quotations",
  },
  ordersListing: {
    heading: "Sale Orders",
    addNewButton: "Add New",
    chooseClient: "Choose Client",
    chooseClientPlaceholder: "Select a client to view his order.",
    chooseClientEmpty: "Clients not available",
  },
  orderAddUpdate: {
    heading: "Sale Orders",
    subHeading: "Add New Sale Order",
    clientDetailHead: "ORDER FOR",
    orderDetailHead: "ORDER",
    chooseClientPlaceholder: "Select a client to view his order.",
    chooseClientEmpty: "Clients not available",
  },
  specificPortals: {
    agentLabel: "Partner",
    agentsLabel: "Partners",
    agentText: "partner",
    agentsText: "partners",
    sharelinkLabel: "Affiliate Link",
    sharelinksLabel: "Affiliate Links",
    sharelinktext: "affiliate link",
    sharelinkstext: "affiliate links",
  },
  loginPage: {
    label: "Sign-In - Internal",
    description: "Enter your details here to login in to our system.",
  },
  //Supplier Listing
  suppliersListing: {
    heading: "Suppliers",
    text: "Supplier",
    addNewButton: "Add New Supplier",
    allCPTab: "All Supplier",
  },
  // Add more pages as needed
};

export default localization;
